import { CalendarGridWeekHeadCell } from './CalendarGridWeekHeadCell'

import * as styles from './CalendarGridWeekHead.module.css'

function CalendarGridWeekHead({
  days,
  outsideHoursItemsByDay,
  today,
  onClickItem,
  onClickSecondaryLabel,
}) {
  return (
    <>
      <div className={styles.corner} />
      {days.map(day => (
        <CalendarGridWeekHeadCell
          day={day}
          days={days}
          key={day.date}
          outsideHoursItems={outsideHoursItemsByDay[day.date]}
          today={today}
          onClickItem={onClickItem}
          onClickSecondaryLabel={onClickSecondaryLabel}
        />
      ))}
    </>
  )
}

export default CalendarGridWeekHead
